import axios from 'axios';
import http from './httpService';
const apiUrl = process.env.REACT_APP_API_URL;

const apiEndpoint = apiUrl + '/operators';

function userUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getOperators() {
  return http.get(apiEndpoint)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
}

export function getOperator(operatorId) {
  return http.get(`${apiEndpoint}/${operatorId}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
}

export function getOperatorByUser(id) {
  return http.get(`${apiEndpoint}/user/${id}`);
}

export function saveOperator(user, imageSrc) {
  if (!process.env.REACT_APP_API_URL) {
    return Promise.reject(new Error("API URL not configured"));
  }

  const formData = new FormData();

  if (user._id) {
    // UPDATE - use PUT /operators/:id with FormData
    const body = { ...user };
    delete body._id;
    
    // Transform data to flat structure for form submission
    if (body.languages && typeof body.languages === 'string') {
      body.languages = body.languages.split(',').map(lang => lang.trim()).filter(lang => lang);
    }
    
    if (body.longitude) body.longitude = parseFloat(body.longitude) || 0;
    if (body.latitude) body.latitude = parseFloat(body.latitude) || 0;
    
    // Convert date to string if it's a Date object
    if (body.dateBirth && typeof body.dateBirth !== 'string') {
      body.dateBirth = body.dateBirth.toISOString();
    }
    
    // Append all fields to FormData (exactly like employee pattern)
    for (let key in body) {
      formData.append(key, body[key]);
    }
    
    // Append imageSrc exactly like employee service
    formData.append('imageSrc', imageSrc);
    
    return http.put(`${apiEndpoint}/${user._id}`, formData, {
      headers: {
        'Content-Type': undefined // Let browser set multipart/form-data with boundary
      }
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }
  
  // CREATE - use POST /operators with FormData (exactly like employee pattern)
  const body = { ...user };
  
  if (body.languages && typeof body.languages === 'string') {
    body.languages = body.languages.split(',').map(lang => lang.trim()).filter(lang => lang);
  }
  
  if (body.longitude) body.longitude = parseFloat(body.longitude) || 0;
  if (body.latitude) body.latitude = parseFloat(body.latitude) || 0;
  
  // Convert date to string if it's a Date object
  if (body.dateBirth && typeof body.dateBirth !== 'string') {
    body.dateBirth = body.dateBirth.toISOString();
  }
  
  // Append all fields to FormData (exactly like employee pattern)
  for (let key in body) {
    formData.append(key, body[key]);
  }
  
  // Append imageSrc exactly like employee service
  formData.append('imageSrc', imageSrc);
  
  return http.post(apiEndpoint, formData, {
    headers: {
      'Content-Type': undefined // Let browser set multipart/form-data with boundary
    }
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
}

export function patchOperator(user, imageSrc) {
  const formData = new FormData();
  if (user._id) {
    const body = { ...user };
    delete body._id;
    delete body.imageSrc;
    for (let key in body) {
      formData.append(key, body[key]);
    }
    formData.append('imageSrc', imageSrc);
    
    return http.patch(`${apiEndpoint}/${user._id}`, formData);
  }
}

export function deleteOperator(operatorId) {
  return http.delete(`${apiEndpoint}/${operatorId}`);
}  